import type { CSSProperties } from "react";
import { type DotLook, dotLook, dotText, FILL_BANDS } from "./fill";
import { CLUSTER_COLOUR, clusterTitle } from "./mapView";

export function LevelDot(look: DotLook) {
  const { className, level } = dotLook(look);
  return (
    <span className={className} style={{ "--level": level } as CSSProperties} aria-hidden="true">
      {dotText(look) || null}
    </span>
  );
}

const SAMPLES = [0.15, 0.4, 0.65, 0.85, 0.95, 1.1];

/** The six fill bands (U-22) as level dots, for the key of a map or a chart. */
export function FillBandKeys() {
  return (
    <>
      {FILL_BANDS.map((band, index) => (
        <li key={band.from} data-testid="fill-key">
          <LevelDot share={SAMPLES[index]} small /> {band.label}
        </li>
      ))}
    </>
  );
}

/** The map key line of a cluster (rule U-23): a rounded square, not a round numbered stop. */
export function ClusterKey({ kind = "accounts" }: { kind?: "accounts" | "leads" }) {
  return (
    <li data-testid="cluster-key">
      <span className="map-cluster key" style={{ background: CLUSTER_COLOUR }} aria-hidden="true">
        N+
      </span>{" "}
      {clusterTitle("N", kind)}
    </li>
  );
}
